import { render, staticRenderFns } from "./ContentPerson.vue?vue&type=template&id=a7399c16&"
import script from "./ContentPerson.vue?vue&type=script&lang=js&"
export * from "./ContentPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports